import {
  LOGIN_META,
  LOGIN_SUCCEEDED,
  LOGOUT_SUCCEEDED,
} from '../constants';

const INITIAL_STATE = {};

export default function customers(state = INITIAL_STATE, action) {
  const {type, payload} = action;

  switch (type) {
  case LOGIN_META: {
    const {entryPath} = payload;
    return {
      ...state,
      entryPath
    };
  }

  case LOGIN_SUCCEEDED:
    return {
      ...state,
      session: true
    };

  case LOGOUT_SUCCEEDED:
    return {
      ...state,
      session: false,
      path: false
    };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js